import { create } from "zustand";

export type ThemeMode = "light" | "dark" | "system";

interface ThemeState {
  themeMode: ThemeMode;
  isDarkMode: boolean;
  setTheme: (mode: ThemeMode) => void;
  toggleTheme: () => void;
}

const STORAGE_KEY = "theme";

const getInitialTheme = (): ThemeMode => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "light" || saved === "dark" || saved === "system") return saved;
  } catch {}
  return "system";
};

const resolveIsDark = (mode: ThemeMode): boolean => {
  if (mode === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  }
  return mode === "dark";
};

export const useThemeStore = create<ThemeState>((set, get) => ({
  themeMode: getInitialTheme(),
  isDarkMode: resolveIsDark(getInitialTheme()),

  setTheme: (mode: ThemeMode) => {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {}
    set({ themeMode: mode, isDarkMode: resolveIsDark(mode) });
  },

  toggleTheme: () => {
    const { themeMode } = get();
    const next: ThemeMode = themeMode === "system" ? "dark" : themeMode === "dark" ? "light" : "system";
    get().setTheme(next);
  },
}));

// 시스템 테마 변경 리스너 (전역 1회)
if (typeof window !== "undefined") {
  const mq = window.matchMedia("(prefers-color-scheme: dark)");
  mq.addEventListener("change", () => {
    const { themeMode } = useThemeStore.getState();
    if (themeMode === "system") {
      useThemeStore.setState({ isDarkMode: mq.matches });
    }
  });
}
